export default __webpack_public_path__ + "static/media/invoice.3bbdbd7e.svg";